export const URL_HOME = '/status'

export const GET_STATUS = 'GET_STATUS'
